/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateParamsDto
 */
export interface CreateUpdateParamsDto {
    /**
     * Parameter group
     * @type {string}
     * @memberof CreateUpdateParamsDto
     */
    group: CreateUpdateParamsDtoGroupEnum;
    /**
     * Parameter name
     * @type {string}
     * @memberof CreateUpdateParamsDto
     */
    name: CreateUpdateParamsDtoNameEnum;
    /**
     * Parameter type
     * @type {string}
     * @memberof CreateUpdateParamsDto
     */
    type: CreateUpdateParamsDtoTypeEnum;
    /**
     * Parameter value
     * @type {string}
     * @memberof CreateUpdateParamsDto
     */
    valueString?: string;
    /**
     * Parameter value
     * @type {boolean}
     * @memberof CreateUpdateParamsDto
     */
    valueBoolean?: boolean;
    /**
     * Parameter value
     * @type {Date}
     * @memberof CreateUpdateParamsDto
     */
    valueDate?: Date;
    /**
     * Parameter value
     * @type {number}
     * @memberof CreateUpdateParamsDto
     */
    valueNumber?: number;
    /**
     * Is parameter editable
     * @type {boolean}
     * @memberof CreateUpdateParamsDto
     */
    isEditable: boolean;
    /**
     * Is parameter visible
     * @type {boolean}
     * @memberof CreateUpdateParamsDto
     */
    isVisible: boolean;
}


/**
 * @export
 */
export const CreateUpdateParamsDtoGroupEnum = {
    Eod: 'EOD',
    Fvz: 'FVZ',
    Ump: 'UMP',
    Sys: 'SYS',
    Surowka: 'Surowka',
    Api: 'API'
} as const;
export type CreateUpdateParamsDtoGroupEnum = typeof CreateUpdateParamsDtoGroupEnum[keyof typeof CreateUpdateParamsDtoGroupEnum];

/**
 * @export
 */
export const CreateUpdateParamsDtoNameEnum = {
    LastProcessedDocumentsDate: 'LastProcessedDocumentsDate',
    LastProcessedClientsDate: 'LastProcessedClientsDate',
    TurnOffPurchaseInvoiceDomestic: 'TurnOffPurchaseInvoiceDomestic',
    DaysToCancelFvzNumber: 'DaysToCancelFVZNumber',
    UmpRequestUserForDebug: 'UMPRequestUserForDebug',
    UmpLogs: 'UMPLogs',
    NewPositionApplicationUrl: 'NewPositionApplicationUrl',
    SurowkaFromYear: 'SurowkaFromYear',
    SurowkaBaseName: 'SurowkaBaseName',
    SurowkaBackupSubfolder: 'SurowkaBackupSubfolder',
    MirrorProjectResponsibleUser: 'MirrorProjectResponsibleUser',
    ContractsForWorkUrl: 'ContractsForWorkUrl',
    SurveyEmailMessagePl: 'SurveyEmailMessagePl',
    SurveyEmailMessageEng: 'SurveyEmailMessageEng',
    MediaplannerApiProjectsByTeamsForCompanies: 'MediaplannerApiProjectsByTeamsForCompanies'
} as const;
export type CreateUpdateParamsDtoNameEnum = typeof CreateUpdateParamsDtoNameEnum[keyof typeof CreateUpdateParamsDtoNameEnum];

/**
 * @export
 */
export const CreateUpdateParamsDtoTypeEnum = {
    String: 'String',
    Boolean: 'Boolean',
    Number: 'Number',
    Date: 'Date'
} as const;
export type CreateUpdateParamsDtoTypeEnum = typeof CreateUpdateParamsDtoTypeEnum[keyof typeof CreateUpdateParamsDtoTypeEnum];


/**
 * Check if a given object implements the CreateUpdateParamsDto interface.
 */
export function instanceOfCreateUpdateParamsDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "group" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "isEditable" in value;
    isInstance = isInstance && "isVisible" in value;

    return isInstance;
}

export function CreateUpdateParamsDtoFromJSON(json: any): CreateUpdateParamsDto {
    return CreateUpdateParamsDtoFromJSONTyped(json, false);
}

export function CreateUpdateParamsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateParamsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'group': json['group'],
        'name': json['name'],
        'type': json['type'],
        'valueString': !exists(json, 'valueString') ? undefined : json['valueString'],
        'valueBoolean': !exists(json, 'valueBoolean') ? undefined : json['valueBoolean'],
        'valueDate': !exists(json, 'valueDate') ? undefined : (new Date(json['valueDate'])),
        'valueNumber': !exists(json, 'valueNumber') ? undefined : json['valueNumber'],
        'isEditable': json['isEditable'],
        'isVisible': json['isVisible'],
    };
}

export function CreateUpdateParamsDtoToJSON(value?: CreateUpdateParamsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'group': value.group,
        'name': value.name,
        'type': value.type,
        'valueString': value.valueString,
        'valueBoolean': value.valueBoolean,
        'valueDate': value.valueDate === undefined ? undefined : (value.valueDate.toISOString()),
        'valueNumber': value.valueNumber,
        'isEditable': value.isEditable,
        'isVisible': value.isVisible,
    };
}

